var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_setting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_setting",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/setting",
    fill: "#BCBEC0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.92276,10.9953733 C16.7920133,10.3478533 16.5364533,9.74493333 16.1823467,9.21288 L17.29592,7.40729333 L16.9366,7.04798667 L16.5772933,6.68868 L14.77176,7.80222667 C14.2397867,7.44813333 13.6368667,7.19256 12.9892133,7.06181333 L12.5004533,5 L11.9923067,5 L11.48416,5 L10.9954,7.06181333 C10.3477467,7.19257333 9.74482667,7.44814667 9.21285333,7.80222667 L7.40732,6.68868 L7.048,7.04798667 L6.68869333,7.40729333 L7.80226667,9.21288 C7.44816,9.74492 7.1926,10.34784 7.06185333,10.9953733 L5,11.4841733 L5,11.9923067 L5,12.50044 L7.06176,12.9892 C7.19245333,13.6369867 7.44797333,14.2400133 7.80204,14.7720667 L6.68869333,16.5773067 L7.048,16.9366133 L7.40732,17.29592 L9.21254667,16.18256 C9.74461333,16.5366533 10.3476267,16.79216 10.9954267,16.9228667 L11.4841733,18.9846 L11.9923067,18.9846 L12.5004533,18.9846 L12.9892,16.9228667 C13.6369867,16.7921467 14.2400133,16.53664 14.77208,16.18256 L16.5772933,17.29592 L16.9366,16.9366133 L17.29592,16.5773067 L16.1825733,14.7720667 C16.53664,14.2400133 16.7921467,13.6369867 16.9228533,12.9892 L18.9846,12.50044 L18.9846,11.9923067 L18.9846,11.4841733 L16.92276,10.9953733 Z M11.9923067,14.9081467 C10.3842,14.9081467 9.07648,13.60044 9.07648,11.9923067 C9.07648,10.3850933 10.3842,9.07646667 11.9923067,9.07646667 C13.6004,9.07646667 14.90812,10.38508 14.90812,11.9923067 C14.90812,13.6004267 13.6004133,14.9081467 11.9923067,14.9081467 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetting);
export default __webpack_public_path__ + "static/media/icon_setting.74e695ac21f622fec41850db7add085f.svg";
export { ForwardRef as ReactComponent };